// import { ChangeEvent, FC, useEffect, useState } from "react";
// import Modal from "react-modal";
// import close from "assets/images/close.svg";
// import Imgclose from "assets/images/input-img-close-icon.svg";
// import Button from "components/particles/primary-button";

// import { Container } from "./style";
// import img from "assets/images/input-img-icon.svg";
// import { useForm } from "react-hook-form";
// import FormErrorMessage from "components/particles/forms/form-error-message";
// import useCategories from "containers/categories/useHook";

// import { dispatch } from "store";
// import { setModalClosed } from "store/user-slice";
// import { useSelector } from "react-redux";
// import { DietariesDTO } from "utils/helpers/models/dietaries.dto";
// import Swal from "sweetalert2";

// interface AddCategoryModelProps {
//   id: number;
//   data: any;
//   dietariesData: any[];
//   setDietariesData: Function;
// }

// const AddDietariesModal: FC<AddCategoryModelProps> = ({
//   id,
//   data,
//   dietariesData,
//   setDietariesData,
// }) => {
//   const {
//     register,
//     handleSubmit,
//     setValue,
//     getValues,
//     formState: { errors },
//     reset,
//   } = useForm<DietariesDTO>({
//     defaultValues: {
//       status: true,
//     },
//   });
//   const [selectedImage, setSelectedImage] = useState<string | null>(null);
//   const { postDietaries, putDietaries } = useCategories();
//   const { addDietariesModalIsOpen } = useSelector((state: any) => state.user);
//   const [status, setStatus] = useState<boolean>(false);

//   const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (!file) return;

//     const validTypes = ["image/jpeg", "image/png", "image/jpg"];
//     const maxSize = 1 * 1024 * 1024;

//     if (!validTypes.includes(file.type)) {
//       Swal.fire({
//         icon: "question",
//         title: "Oops...",
//         text: "Only JPG, JPEG, PNG allowed",
//         confirmButtonText: "OK",
//       });
//       event.target.value = "";
//       return;
//     }

//     if (file.size > maxSize) {
//       Swal.fire({
//         icon: "question",
//         title: "Oops...",
//         text: "Image must be less than or equal to 1MB.",
//         confirmButtonText: "OK",
//       });
//       event.target.value = "";
//       return;
//     }

//     setSelectedImage(URL.createObjectURL(file));
//     setValue("image", file);
//   };

//   const customStyles = {
//     content: {
//       top: "50%",
//       left: "50%",
//       right: "auto",
//       bottom: "auto",
//       marginRight: "-50%",
//       transform: "translate(-50%, -50%)",
//       fontSize: "2rem",
//       width: "68.5rem",
//       borderRadius: "3rem",
//     },
//   };

//   function closeModal() {
//     dispatch(setModalClosed("Dietaries"));
//   }

//   function closeImg() {
//     setSelectedImage(null);
//     setValue("name", "");
//   }

//   useEffect(() => {
//     if (id === 0) {
//       reset();
//       setSelectedImage(null);
//       setStatus(true);
//     } else if (data) {
//       for (let key in new DietariesDTO()) {
//         if (data[key] !== undefined) {
//           if ((key as keyof DietariesDTO) === "image") {
//             setSelectedImage(data[key]);
//           }
//           if (key === "status") {
//             setStatus(data[key]);
//           }
//           setValue(key as keyof DietariesDTO, data[key]);
//         }
//       }
//     }
//   }, [data, id, reset]);

//   const onSubmit = (data: DietariesDTO) => {
//     const formData = new FormData();
//     for (let key in getValues()) {
//       if ((key as keyof DietariesDTO) === "status") {
//         const status: any = getValues("status") == "Active";
//         formData.append(key, status);
//       } else {
//         formData.append(key, getValues(key as keyof DietariesDTO));
//       }
//     }

//     if (id === 0) {
//       postDietaries(formData);
//     } else {
//       putDietaries(id, formData, dietariesData, setDietariesData, data);
//     }
//   };

//   const handleStatusChange = (e: ChangeEvent<HTMLSelectElement>) => {
//     const newStatus = e.target.value === "Active";
//     setStatus(newStatus);
//     setValue("status", newStatus);
//   };

//   return (
//     <Modal
//       isOpen={addDietariesModalIsOpen}
//       onRequestClose={closeModal}
//       style={customStyles}
//       contentLabel="Example Modal"
//     >
//       <Container onSubmit={handleSubmit(onSubmit)}>
//         <div className="close-button" onClick={closeModal}>
//           <img src={close} style={{ cursor: "pointer" }} alt="img" />
//         </div>
//         <div className="model-container">
//           <div
//             className="popup-title"
//             style={{ width: "100%", textAlign: "center", marginTop: "4rem" }}
//           >
//             <h1>{id === 0 ? "Add Dietary" : "Update Dietary"}</h1>
//           </div>
//           <div className="add-ingredient-container">
//             <div className="image-container">
//               <div className="image-input-wrapper">
//                 {selectedImage ? (
//                   <>
//                     <img
//                       className="uploaded-image"
//                       src={selectedImage}
//                       alt="Selected"
//                     />
//                     <img
//                       className="close-icon"
//                       src={Imgclose}
//                       alt="Remove"
//                       onClick={closeImg}
//                     />
//                   </>
//                 ) : (
//                   <>
//                     <label htmlFor="image-input">
//                       <img src={img} alt="Upload" />
//                     </label>
//                     <input
//                       id="image-input"
//                       type="file"
//                       accept="image/*"
//                       className="hidden-input"
//                       {...register("image", {
//                         validate: {
//                           fileSize: (fileList) => {
//                             const file = fileList?.[0];
//                             if (!file) return true;
//                             return (
//                               file.size <= 1 * 1024 * 1024 ||
//                               "File size must be ≤ 1MB"
//                             );
//                           },
//                           fileType: (fileList) => {
//                             const file = fileList?.[0];
//                             if (!file) return true;
//                             return (
//                               ["image/jpeg", "image/png", "image/jpg"].includes(
//                                 file.type
//                               ) || "Only JPG, JPEG, PNG allowed"
//                             );
//                           },
//                         },
//                       })}
//                       onChange={handleImageChange}
//                     />
//                     <FormErrorMessage error={errors.image} />
//                   </>
//                 )}
//               </div>
//               <p>{getValues("image.name")}</p>
//               {/* <input type="text" placeholder="Your input here" style={{ flex: 1, border: 'none', backgroundColor: 'transparent', outline: 'none' }} /> */}
//             </div>
//             <div>
//               <input
//                 type="text"
//                 placeholder="Dietary Name"
//                 {...register("name", { required: true })}
//               />
//               <FormErrorMessage error={errors.name} />
//             </div>
//             <select
//               id="Status"
//               {...register("status")}
//               value={status ? "Active" : "Inactive"}
//               onChange={handleStatusChange}
//               required
//             >
//               <option>Active</option>
//               <option>Inactive</option>
//             </select>
//           </div>
//           <div className="add-button">
//             <Button
//               title={id === 0 ? "Add" : "Update"}
//               width="51.2rem"
//               backgroundcolor="var(--primary)"
//               fill="true"
//             />
//           </div>
//         </div>
//       </Container>
//     </Modal>
//   );
// };

// export default AddDietariesModal;

import { ChangeEvent, FC, useEffect, useState } from "react";
import Modal from "react-modal";
import close from "assets/images/close.svg";
import Imgclose from "assets/images/input-img-close-icon.svg";
import Button from "components/particles/primary-button";

import { Container } from "./style";
import img from "assets/images/input-img-icon.svg";
import { useForm } from "react-hook-form";
import FormErrorMessage from "components/particles/forms/form-error-message";
import useCategories from "containers/categories/useHook";

import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";
import { useSelector } from "react-redux";
import { DietariesDTO } from "utils/helpers/models/dietaries.dto";
import Swal from "sweetalert2";

interface AddCategoryModelProps {
  id: number;
  data: any;
  dietariesData: any[];
  setDietariesData: Function;
  refreshData?: Function; // Add optional refresh function
}

const AddDietariesModal: FC<AddCategoryModelProps> = ({
  id,
  data,
  dietariesData,
  setDietariesData,
  refreshData,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    reset,
  } = useForm<DietariesDTO>({
    defaultValues: {
      status: true,
    },
  });
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const { postDietaries, putDietaries } = useCategories();
  const { addDietariesModalIsOpen } = useSelector((state: any) => state.user);
  const [status, setStatus] = useState<boolean>(true); // Default to true

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 1 * 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "question",
        title: "Oops...",
        text: "Only JPG, JPEG, PNG allowed",
        confirmButtonText: "OK",
      });
      event.target.value = "";
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "question",
        title: "Oops...",
        text: "Image must be less than or equal to 1MB.",
        confirmButtonText: "OK",
      });
      event.target.value = "";
      return;
    }

    setSelectedImage(URL.createObjectURL(file));
    setValue("image", file);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      fontSize: "2rem",
      width: "68.5rem",
      borderRadius: "3rem",
    },
  };

  function closeModal() {
    dispatch(setModalClosed("Dietaries"));
    // Reset state when closing
    reset();
    setSelectedImage(null);
    setStatus(true);
  }

  function closeImg() {
    setSelectedImage(null);
    setValue("image", "");
  }

  useEffect(() => {
    if (id === 0) {
      // Adding new dietary
      reset();
      setSelectedImage(null);
      setStatus(true);
      setValue("status", true);
    } else if (data) {
      // Editing existing dietary
      for (let key in new DietariesDTO()) {
        if (data[key] !== undefined) {
          if ((key as keyof DietariesDTO) === "image") {
            setSelectedImage(data[key]);
          }
          if (key === "status") {
            // Handle both string and boolean status values from API
            const statusValue = data[key] === true || data[key] === "true";
            setStatus(statusValue);
            setValue("status", statusValue);
          } else {
            setValue(key as keyof DietariesDTO, data[key]);
          }
        }
      }
    }
  }, [data, id, reset, setValue]);

  const onSubmit = async (formData: DietariesDTO) => {
    const submitData = new FormData();
    
    // Get current form values
    const currentValues = getValues();
    
    // Handle each field explicitly to avoid TypeScript index signature issues
    Object.keys(currentValues).forEach((key) => {
      const typedKey = key as keyof DietariesDTO;
      const value = currentValues[typedKey];
      
      if (key === "status") {
        // Use the current status state value
        submitData.append(key, status.toString());
      } else if (key === "image" && value) {
        // Handle image file
        if (value instanceof File) {
          submitData.append(key, value);
        }
      } else if (value !== undefined && value !== null && value !== "") {
        submitData.append(key, String(value));
      }
    });

    try {
      if (id === 0) {
        // Adding new dietary
        await postDietaries(submitData);
      } else {
        // Updating existing dietary
        await putDietaries(id, submitData, dietariesData, setDietariesData, data);
        
        // After successful update, refresh the data to get the latest status
        if (refreshData) {
          refreshData();
        }
      }
      
      closeModal();
    } catch (error) {
      console.error("Error submitting dietary:", error);
    }
  };

  const handleStatusChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value === "Active";
    setStatus(newStatus);
    setValue("status", newStatus);
  };

  return (
    <Modal
      isOpen={addDietariesModalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Add/Edit Dietary Modal"
    >
      <Container onSubmit={handleSubmit(onSubmit)}>
        <div className="close-button" onClick={closeModal}>
          <img src={close} style={{ cursor: "pointer" }} alt="Close" />
        </div>
        <div className="model-container">
          <div
            className="popup-title"
            style={{ width: "100%", textAlign: "center", marginTop: "4rem" }}
          >
            <h1>{id === 0 ? "Add Dietary" : "Update Dietary"}</h1>
          </div>
          <div className="add-ingredient-container">
            <div className="image-container">
              <div className="image-input-wrapper">
                {selectedImage ? (
                  <>
                    <img
                      className="uploaded-image"
                      src={selectedImage}
                      alt="Selected"
                    />
                    <img
                      className="close-icon"
                      src={Imgclose}
                      alt="Remove"
                      onClick={closeImg}
                    />
                  </>
                ) : (
                  <>
                    <label htmlFor="image-input">
                      <img src={img} alt="Upload" />
                    </label>
                    <input
                      id="image-input"
                      type="file"
                      accept="image/*"
                      className="hidden-input"
                      {...register("image", {
                        validate: {
                          fileSize: (fileList) => {
                            const file = fileList?.[0];
                            if (!file) return true;
                            return (
                              file.size <= 1 * 1024 * 1024 ||
                              "File size must be ≤ 1MB"
                            );
                          },
                          fileType: (fileList) => {
                            const file = fileList?.[0];
                            if (!file) return true;
                            return (
                              ["image/jpeg", "image/png", "image/jpg"].includes(
                                file.type
                              ) || "Only JPG, JPEG, PNG allowed"
                            );
                          },
                        },
                      })}
                      onChange={handleImageChange}
                    />
                    <FormErrorMessage error={errors.image} />
                  </>
                )}
              </div>
              <p>{getValues("image")?.name || ""}</p>
            </div>
            <div>
              <input
                type="text"
                placeholder="Dietary Name"
                {...register("name", { required: "Dietary name is required" })}
              />
              <FormErrorMessage error={errors.name} />
            </div>
            <select
              id="Status"
              value={status ? "Active" : "Inactive"}
              onChange={handleStatusChange}
              required
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
          <div className="add-button">
            <Button
              title={id === 0 ? "Add" : "Update"}
              width="51.2rem"
              backgroundcolor="var(--primary)"
              fill="true"
            />
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default AddDietariesModal;